module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.8669b870.ttf";